function ListingNeighborHoods({neighborhood}){
    return(
        <button>{neighborhood}</button>
    )
}

export default ListingNeighborHoods;